<template>
    <b-modal
            id="ModalUpdatePage"
            ref="ModalUpdatePage">
        <div slot="modal-title">
            <h4>Необходимо обновить страницу</h4>
        </div>
        <div class="alert alert-warning">
            <h1 class="text-center"><i class="fa fa-refresh"></i></h1>
            <h4>
                Привет {{user.firstname}} <br> Приятная новость - Аларм План был обновлен
            </h4>
            <p>
                Обновление необходимо для улучшения стабильности работы и добавления нового функционала.
            </p>
            <p>
                Для стабильной работы необходимо обновить страницу. Рекомендуется обновить страницу с очисткой кеша нажав CTRL + F5 на клавиатуре.
            </p>
            <p>
                Приносим свои извинения за доставленные не удобства.
            </p>
        </div>
        <div slot="modal-footer">
            <b-btn variant="primary" @click.prevent="updatePage">Обновить Аларм План</b-btn>
        </div>
    </b-modal>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    props: ['show'],
    computed: mapState({
      user: state => state.globalStore.user
    }),
    data () {
      return {}
    },
    methods: {
      updatePage () {
        this.$router.go()
      },
      updatePageEventListner (event) {
        console.log('Необходимо обновить страницу')
        this.$refs.ModalUpdatePage.show()
      }
    },
    components: {
      //
    },
    created () {
      this.$echo.private('user.' + this.user.id)
        .listen('.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated', (event) => {
          switch (event.type) {
            case 'App\\Notifications\\UpdateFrontend':
              this.updatePageEventListner(event)
              break
          }
        })
    }
  }
</script>



// WEBPACK FOOTER //
// ModalUpdatePage.vue?ef6f7df6